import type {
  FormArray,
  FormControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export class IsNotValidators {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static isNot(value: any): ValidatorFn {
    return (array: FormArray | FormControl): ValidationErrors | null => {
      if (!array) {
        return null;
      }

      if (array.value === value) {
        return { isNot: { valid: false } };
      }

      return null;
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static isNotIn(value: any[]): ValidatorFn {
    return (array: FormArray | FormControl): ValidationErrors | null => {
      if (!array) {
        return null;
      }

      if (value.includes(array.value)) {
        return { isNot: { valid: false } };
      }

      return null;
    };
  }
}
